import React from 'react';
import PageToggleBanner from './PageToggleBanner';

const CONTACT_TYPES = [
  { id: 'email', label: 'Email', placeholder: 'your@email.com' },
  { id: 'phone', label: 'Phone', placeholder: '+1 (555) 123-4567' },
  { id: 'website', label: 'Website', placeholder: 'https://yoursite.com' },
  { id: 'instagram', label: 'Instagram', placeholder: '@yourhandle' },
  { id: 'agent', label: 'Agent / Manager', placeholder: 'Name, agency, contact info' },
  { id: 'youtube', label: 'YouTube', placeholder: 'Channel URL' },
  { id: 'tiktok', label: 'TikTok', placeholder: '@yourhandle' },
  { id: 'other', label: 'Other', placeholder: 'Any additional info' },
];

function ContactTab({
  hiddenSections,
  handleToggleSection,
  contactLinks,
  newLink,
  setNewLink,
  handleAddLink,
  handleDeleteLink,
  contactBlurb,
  setContactBlurb,
  handleSaveAll,
}) {
  const selectedType = CONTACT_TYPES.find((t) => t.id === newLink.link_type) || CONTACT_TYPES[0];

  return (
    <>
      {/* REVIEW: extracted to PageToggleBanner */}
      <PageToggleBanner
        label="Contact Page"
        enabled={!hiddenSections.includes('contact')}
        onToggle={() => handleToggleSection('contact')}
      />

      <div className="settings-card">
        <div className="settings-card-header">
          <h2>Contact Blurb</h2>
          <p>A short message above your contact info.</p>
        </div>
        <textarea
          className="contact-blurb-textarea"
          value={contactBlurb || ''}
          onChange={(e) => setContactBlurb(e.target.value)}
          onBlur={() => handleSaveAll && handleSaveAll()}
          placeholder="e.g. Open to new representation. Available for regional and touring work starting June 2026."
          rows={3}
        />
      </div>

      <div className="settings-card">
        <div className="settings-card-header">
          <h2>Contact Info</h2>
          <p>Add your contact details, socials, and representation.</p>
        </div>

        {contactLinks.length > 0 && (
          <div className="contact-list">
            {contactLinks.map((link) => (
              <div key={link.id} className="contact-item">
                <div className="contact-item-type">{link.label}</div>
                <div className="contact-item-value">{link.url}</div>
                <button className="contact-item-remove" onClick={() => handleDeleteLink(link.id)}>
                  ×
                </button>
              </div>
            ))}
          </div>
        )}

        <div className="contact-add-section">
          <div className="contact-add-form">
            <select
              className="contact-type-select"
              value={newLink.link_type || 'email'}
              onChange={(e) => {
                const type = CONTACT_TYPES.find((t) => t.id === e.target.value);
                setNewLink({ ...newLink, link_type: e.target.value, label: type?.label || '' });
              }}
            >
              {CONTACT_TYPES.map((type) => (
                <option key={type.id} value={type.id}>
                  {type.label}
                </option>
              ))}
            </select>
            <input
              type="text"
              className="contact-value-input"
              value={newLink.url || ''}
              onChange={(e) => setNewLink({ ...newLink, url: e.target.value })}
              placeholder={selectedType.placeholder}
              onKeyDown={(e) => e.key === 'Enter' && handleAddLink()}
            />
            <button
              className="contact-add-btn"
              onClick={handleAddLink}
              disabled={!newLink.url?.trim()}
            >
              Add
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactTab;
